import { render, staticRenderFns } from "./ManuscriptListItem.vue?vue&type=template&id=51687dc7&scoped=true"
import script from "./ManuscriptListItem.vue?vue&type=script&lang=ts"
export * from "./ManuscriptListItem.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptListItem.vue?vue&type=style&index=0&id=51687dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51687dc7",
  null
  
)

export default component.exports